import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentService } from 'src/app/services/document/document.service';
import { UserData } from '../../documents/add-useful-document/add-useful-document.component';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { AppService } from 'src/app/services/app/app.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-assign-staff-survey',
  templateUrl: './assign-staff-survey.component.html',
  styleUrls: ['./assign-staff-survey.component.scss']
})
export class AssignStaffSurveyComponent {
  public assignForm!: FormGroup;
  public userType: string = 'department';
  dropdownSettings: IDropdownSettings = {};
  dropdownSettingsEmp: IDropdownSettings = {};
  dropdownSettingsMan: IDropdownSettings = {};
  public userData!: UserData;
  public departmentArr: any[] = []
  public empArr: any[] = []
  public managerArr: any[] = []
  public isErr: boolean = false;
  
  constructor(private fb: FormBuilder, private commonService:CommonService, private docService: DocumentService, private spinner: NgxSpinnerService, private surveyService: StaffSurveyService,
    private appService: AppService, @Inject(MAT_DIALOG_DATA) public dialogData:any,public dialogRef: MatDialogRef<AssignStaffSurveyComponent>) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.assignForm = this.fb.group({
      'all_user': '',
      d_i: [''],
      ma_i: [''],
      em_i: ['']
    })
    this.dropdownSettings = {
      idField: 'd_i',
      textField: 'dep',
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsEmp = {
      idField: 'em_i',
      textField: 'name',
      "allowSearchFilter": true
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsMan = {
      idField: 'ma_i',
      textField: 'name',
      "allowSearchFilter": true
      // below setting will help to enable search filter in multi select dropdown
    };
    this.getList()
  }
  onUserType(value: string) {
    this.userType = value
  }
  getList() {
    this.spinner.show();
    this.docService.getAllUserListing().subscribe({
       next :(success: any) => {
      this.spinner.hide();
      if (success.status == 200) {
        this.departmentArr = success.data.department_list
        this.managerArr = success.data.manager
        this.empArr = success.data.employee
        this.empArr.map(item => item["name"] = item["f_n"] + ' ' + item["l_n"])
        this.managerArr.map(item => item["name"] = item["f_n"] + ' ' + item["l_n"])
        this.spinner.hide();
      }
    },
     error: (error: any) => {
          this.commonService.handleError(error);
        },
    });
  }
  checkDataAvailable() {
    if (this.assignForm.value.all_user != true) {
      this.isErr = true;
      if (this.userType == 'department') {
        if (this.assignForm.value.d_i.length > 0) {
          this.isErr = false;
        }
      }
      if (this.userType == 'manager') {
        if (this.assignForm.value.ma_i.length > 0) {
          this.isErr = false;
        }
      }
      if (this.userType == 'employee') {
        if (this.assignForm.value.em_i.length > 0) {
          this.isErr = false;
        }
      }
    }
    else {
      this.isErr = false
    }
  }
  addId(formName: string, arrName: any[]) {
    let value;
    if (this.assignForm.value[formName].length == arrName.length) {
      value = 'all'
    }
    else {
      let newArr: any[] = [];
      for (let i = 0; i < this.assignForm.value[formName].length; i++) {
        newArr.push(this.assignForm.value[formName][i][formName])
      }
      value = newArr
    }
    return value
  }
  onSubmit() {
    this.checkDataAvailable()
    if (this.isErr == false) {
      let dataObj = {}
      dataObj['su_i']=this.dialogData;
      dataObj['ma_i'] = []
      dataObj['d_i'] = []
      dataObj['em_i'] = []
      if (this.assignForm.value.all_user !== true) {
        dataObj['all_user'] = false
        if (this.userType == 'manager') {
          dataObj['ma_i'] = this.addId('ma_i', this.managerArr)
        }
        if (this.userType == 'employee') {
          dataObj['em_i'] = this.addId('em_i', this.empArr)
        }
        if (this.userType == 'department') {
          dataObj['d_i'] = this.addId('d_i', this.departmentArr)
        }
      }
      else {
        dataObj['all_user'] = true;
      }
      this.surveyService.assignSurvey(dataObj).subscribe({
       next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.onCancel()
        }
    },
      error: (error: any) => {
          this.commonService.handleError(error);
        },
      })
    }
  }
  onCancel(){
    this.dialogRef.close()
  }
}
